module.exports = __webpack_public_path__ + "img/Fotocomunidad.784da913.png";